<template>
  <div class="infiniteScroll" ref="infiniteScroll">
    <slot/>

    <div class="load-box" ref="loadBox">
      <p v-if="loading">加载中...</p>
      <p v-if="infiniteScrollDisabled">没有更多了</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infiniteScroll: {
      require: true,
      type: Function,
    },
    infiniteScrollDelay: {
      type: Number,
      default: 200
    },
    infiniteScrollDistance: {
      type: Number,
      default: 0.5
    },
    infiniteScrollDisabled: {
      type: Boolean,
      default: false
    },
    infiniteScrollImmediate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    hasScroll() {
      const el = this.$refs.infiniteScroll
      if(el){
        return el.scrollHeight > el.clientHeight
      }
      return false
    }
  },
  mounted() {
    const middleScroll = (_scroll, _delay) => {
      const scroll = _scroll;
      const delay = _delay;
      this.loading = false
      let preLoadTime = 0
      const loadF = async () => {
        if(this.infiniteScrollDisabled) return;
        const curTime = new Date().getTime()
        if(!(curTime - preLoadTime >= delay)) return;
        if(this.loading) return;
        const {scrollTop, clientHeight, scrollHeight} = this.$refs.infiniteScroll
        if(!(scrollHeight - scrollTop - clientHeight <= this.infiniteScrollDistance)) return;
        preLoadTime = curTime
        this.loading = true
        try {
          await scroll()
        } catch (error) {
          // error
        }
        this.loading = false

        this.$nextTick(()=>{
          if(this.hasScroll === false && this.infiniteScrollDisabled === false) {
            loadF()
          }
        })
      }
      return loadF
    }
    const loadFn = middleScroll(this.infiniteScroll, this.infiniteScrollDelay)
    this.$refs.infiniteScroll.addEventListener('scroll', loadFn)
    this.$once('hook:beforeDestroy', ()=>{
      this.$refs.infiniteScroll.removeEventListener('scroll', loadFn)
    })
    if(this.infiniteScrollImmediate){
      loadFn()
    }
  },
}
</script>


<style scoped>
.load-box{
  text-align: center;
  padding-top: 15px;
}
</style>